import React, { Fragment, useCallback } from 'react'
import { styled } from '@mui/system'
import { alpha } from '@mui/material/styles'
import ActionDelete from '@mui/icons-material/Delete'
import {
  Button,
  Confirm,
  useDelete,
  useDeleteWithConfirmController,
  useNotify,
  useRedirect,
  useTranslate,
} from 'react-admin'

export const DeleteButtonWithConfirmation = ({
  resource,
  record,
  name,
  genderElement,
  label,
  redirectTo = 'list',
  onClick,
  handleDeleteFunction = null,
  ...rest
}) => {
  const redirect = useRedirect()
  const translate = useTranslate()
  const notify = useNotify()
  const { open, isLoading, handleDialogOpen, handleDialogClose } = useDeleteWithConfirmController({
    resource,
    record,
    redirect: redirectTo,
    onClick,
  })
  const [deleteOne] = useDelete()

  const onSuccess = (res) => {
    if(res.inactive){
        notify('ra.notification.inactive_business_unit', {type:'success'})
    } else {
        notify(`ra.notification.deleted_success_${genderElement}`, {
            type: 'success',
            messageArgs: { element: translate(`ra.single_entity.${resource}`) },
        })
    }
    
    redirect(redirectTo, resource)
  }

  const onError = () => {
    notify(`ra.notification.deleted_error_${genderElement}`, {
      type: 'error',
      messageArgs: { element: translate(`ra.single_entity.${resource}`) },
    })
  }

  const handleDelete = useCallback(
    async (e) => {
        e.stopPropagation()
        deleteOne(
            resource,
            { id: record.id, previousData: record },
            {
            onSuccess: (res) => {
                handleDialogClose(e)
                onSuccess(res)
            },
            onError: () => {
                handleDialogClose(e)
                onError()
            }
            }
        )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [redirectTo, resource, record, genderElement]
  )

  return (
    <Fragment>
      <StyledButton
        className='ra-delete-button'
        onClick={handleDialogOpen}
        label={label}
        startIcon={<ActionDelete />}
        {...rest}
      />
      <Confirm
        isOpen={open}
        loading={isLoading}
        title='ra.message.delete_title'
        content='ra.message.delete_content'
        translateOptions={{
          resource: translate(`ra.single_entity.${resource}`),
          name: name,
        }}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </Fragment>
  )
}

const StyledButton = styled(Button, {
  name: 'RaDeleteWithConfirmButton',
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  color: theme.palette.error.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.error.main, 0.12),
    // Reset on mouse devices
    '@media (hover: none)': {
      backgroundColor: 'transparent',
    },
  },
}))